package ui

import common.frontend.api.*
import io.*
import kotlinx.coroutines.*
import tk.mallumo.compose.navigation.viewmodel.*

@VM
class GlobalVM : NavigationViewModel() {

    var companyWithLocation: Io.BundleCompanyWithLocation? = null
        private set


    fun reloadCompanyWithLocation(login: Io.User) {
        scope.launch {
            runCatching {
                if (!login.permission.canLocation(Io.Permission.OWN_VIEW)) error("unable")
                companyWithLocation = Repository.api.device.bundleCompanyWithLocation()
            }
        }
    }

    override fun onRelease() = Unit
}
